import { EDisplayFormat } from '@shelflix/schemas/_common/enum';

export const campaignDisplayFormatMapper = (format: EDisplayFormat): string => {
  switch (format) {
    case EDisplayFormat.LANDSCAPE:
      return 'Horizontal';
    case EDisplayFormat.PORTRAIT:
      return 'Vertical';
    default:
      return 'Unknown Format';
  }
};
